"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Attach = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  clipRule: "evenodd",
  d: "M1.216 14.007C-.5 12.291-.39 9.69 1.48 7.82l4.987-4.987C8.809.491 12.229.381 14.424 2.576c2.195 2.195 2.085 5.615-.256 7.956L10.06 14.64l-1.185-1.184 4.107-4.107c1.7-1.7 1.812-4.055.268-5.599-1.544-1.544-3.9-1.432-5.599.268L2.666 9.004c-1.023 1.022-1.504 2.603-.277 3.83 1.227 1.227 2.808.746 3.83-.277l4.4-4.4c.354-.353 1.087-1.26.285-2.061-.802-.802-1.708-.069-2.061.285l-4.107 4.106L3.55 9.303l4.107-4.107c1.404-1.404 3.18-1.513 4.42-.274 1.24 1.24 1.13 3.016-.274 4.42l-4.4 4.4c-1.87 1.87-4.472 1.981-6.188.265z"
}));

var _default = Attach;
exports.default = _default;